import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../internal/cx';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Plano por decisão do owner (D-099, brandbook §10.3 — material sóbrio e plano; nenhuma
   * sombra em card comum, nunca glow/gradiente/sombra ornamental). `default` e `flat` hoje
   * têm o mesmo material; `flat` é mantido por compatibilidade de API para contextos
   * aninhados. Elevação real só em Dialog e Toast. */
  variant?: 'default' | 'flat';
}

export function Card({ children, className, variant = 'default', ...rest }: CardProps) {
  return (
    <div className={cx('argink-card', `argink-card--${variant}`, className)} {...rest}>
      {children}
    </div>
  );
}
